"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ImageUnsupportedType extends client_library_1.ExtendableError {
    constructor(contentType) {
        super(`Unsupported image type: ${contentType}`);
    }
}
exports.default = ImageUnsupportedType;
